import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import {
  MultiSelectionPayload,
  SelectionModel,
  SelectionPayload,
  SelectionTypePayload,
} from '../../../common/models/selection.model';

// identifier
export const SELECTION_SLICE_ID = 'selection';

// default state
const initialState: SelectionModel = {};

//slice
const selectionSlice = createSlice({
  name: SELECTION_SLICE_ID,
  initialState,
  reducers: {
    multiSelect: (state: SelectionModel, action: PayloadAction<MultiSelectionPayload>) => {
      const { type, value } = action.payload;
      if (!state[type]) {
        state[type] = [];
      }
      const diff: unknown[] = [];
      value.forEach((val) => {
        const index = state[type].indexOf(val);
        if (index === -1) {
          diff.push(val);
        }
      });
      state[type] = [...state[type], ...diff];
    },
    multiDeselect: (state: SelectionModel, action: PayloadAction<MultiSelectionPayload>) => {
      const { type, value } = action.payload;
      if (!state[type]) {
        state[type] = [];
      }
      const nextState = [...state[type]];
      value.forEach((val: unknown) => {
        const index = state[type].indexOf(val);
        if (index > -1) {
          nextState.splice(index, 1);
        }
      });
      state[type] = nextState;
    },
    select: (state: SelectionModel, action: PayloadAction<SelectionPayload>) => {
      const { type, value } = action.payload;
      if (!state[type]) {
        state[type] = [];
      }
      const repository = state[type];
      const alreadySelected = repository.includes(value);
      if (!alreadySelected) {
        repository.push(value);
      }
    },
    deselect: (state: SelectionModel, action: PayloadAction<SelectionPayload>) => {
      const { type, value } = action.payload;
      if (!state[type]) {
        state[type] = [];
      }
      const index = state[type].indexOf(value);
      if (index > -1) {
        const nextState = [...state[type]];
        nextState.splice(index, 1);
        state[type] = nextState;
      }
    },
    clearSelection: (state: SelectionModel, action: PayloadAction<SelectionTypePayload>) => {
      const { type } = action.payload;
      if (!state[type]) {
        state[type] = [];
      }
      state[type] = [];
    },
  },
});

//selectors
export const selectSelection = (state: RootState) => state.selection;

//actions
export const { multiSelect, multiDeselect, select, deselect, clearSelection } =
  selectionSlice.actions;

//reducer
export default selectionSlice;
